import React, { PropsWithChildren } from 'react';

import { useFirebaseSync } from './FirebaseProvider.utils';

interface Props {
	isEnabled: boolean;
}

function FirebaseProvider({ children, isEnabled }: PropsWithChildren<Props>): JSX.Element {
	useFirebaseSync({ isEnabled });

	return <>{children}</>;
}

export default FirebaseProvider;
